import { createSlice } from "@reduxjs/toolkit";

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        switch: false,
        variant: null,
        message: null
    },
    reducers: {
        setMessage: (state, props) => {          
            state.variant = props.payload?.variant || 'danger';
            state.message = props.payload.message;
            state.switch = true;
        },
        closeAlerts: (state, props) => {
            state.variant = null;
            state.message = null;
            state.switch = false;
        }
    }
})

export const { setMessage, closeAlerts } = alertSlice.actions;
export default alertSlice.reducer;
